module.exports = __webpack_public_path__ + "static/media/frames-6.c9e30d69.jpg";